import React, { useEffect, useRef, useState } from "react";
import Select from "../../../../components/form/select/Select";
import { useFormik } from "formik";
import * as yup from "yup";
import { useSelector } from "react-redux";
import { resetReport } from "../../../../redux/slice/report/reportSlice";
import { useDispatch } from "react-redux";
import {
  sortCustomersByOffice,
  sortCustomersByStaff,
  // sortPoliciesByOffice,
  // sortPoliciesByStaff,
  sortUsersByOffice,
} from "../../../../utils/helpers/functions";
import { BounceLoader } from "react-spinners";

const statusData = [
  { name: "Pending", id: "1" },
  { name: "Active", id: "2" },
  { name: "Rejected", id: "3" },
  { name: "Closed", id: "4" },
];

const policyData = [
  { name: "Pending", id: "1" },
  { name: "Active", id: "2" },
  { name: "Matured", id: "3" },
];

const claimsType = [
  { name: "Maturity", id: "1" },
  { name: "Termination", id: "2" },
  { name: "Partial Withdrawal", id: "3" },
  { name: "Death Benefit", id: "4" },
];

const ReportFilter = ({
  page,
  setFilteredItem,
  filteredItem,
  setFilterData,
}) => {
  const [sortedCustomers, setSortedCustomers] = useState([]);
  // const [sortedPolicies, setSortedPolicies] = useState([]);

  const { isLoading } = useSelector((state) => state.report);
  const { unpaginated_users } = useSelector((state) => state?.user);
  const { user } = useSelector((state) => state?.auth?.user);
  const { unpaginated_customers } = useSelector((state) => state?.customer);
  const { unpaginated_policy } = useSelector((state) => state?.policy);
  const { unpaginated_savings_policy } = useSelector((state) => state?.savingsPolicy);

  const {
    offices: { offices },
  } = useSelector((state) => state.office);

  const [sortedUsers, setSortedUsers] = useState(
    sortUsersByOffice(user?.office_id, unpaginated_users)
  );
  const currentDate = new Date().toISOString().split("T")[0];

  const agentCusRef = useRef();
  const actionCusRef = useRef();
  const officeRef = useRef();
  const customerRef = useRef();
  const appliedPoliciesRef = useRef();
  const policyStatusRef = useRef();
  const policyRef = useRef();

  const dispatch = useDispatch();

  const {
    errors,
    values,
    touched,
    handleBlur,
    handleChange,
    handleSubmit,
    setFieldValue,
    setFieldError,
    resetForm,
  } = useFormik({
    // enableReinitialize: true,
    initialValues: {
      office_id: user?.office_id,
      staff_id: "",
      customer_id: "",
      policy_id: "",
      policyStatus_id: "",
      status: "",
      claim_status: "",
      action: "",
      savings_policy_id: "",
      claim_category: "other_cover",
      claim_type: "",
      start_date: currentDate,
      end_date: currentDate,
    },
    validationSchema: () =>
      yup.object().shape({
        start_date: yup.string().required("Start Date is required"),
        end_date: yup.string().required("End Date is required"),
      }),
    validate: (values) => {
      let errors = {};
      if (values.start_date > values.end_date) {
        errors.end_date = "End Date cannot be behind Start Date";
      }
      if (page === "agentReport" && !values.policyStatus_id) {
        errors.policyStatus_id = "Policy Status is Required";
      }
      if (page === "savingsClaim" && !values.claim_category) {
        errors.claim_category = "Claim Category is Required";
      }
      return errors;
    },
    onSubmit: (values) => {
      if (values?.staff_id === undefined) {
        values["staff_id"] = "";
      }
      setFilteredItem(true);
      setFilterData(values);
    },
  });

  const clearFilteredItems = () => {
    appliedPoliciesRef?.current?.clearValue();
    actionCusRef?.current?.clearValue();
    officeRef?.current?.clearValue();
    resetForm();
    setFilteredItem(false);
    dispatch(resetReport());
  };

  useEffect(() => {
    agentCusRef?.current?.clearValue();
    if (values?.office_id) {
      let sortedUsers = sortUsersByOffice(values?.office_id, unpaginated_users);
      setSortedUsers(sortedUsers);
    } else {
      setSortedUsers([]);
    }
  }, [values?.office_id, unpaginated_users,]);

  // useEffect(() => {
  //   if (values?.staff_id) {
  //     let sortedPolicies = sortPoliciesByStaff(
  //       values?.staff_id,
  //       unpaginated_applied_policy
  //     );
  //     setSortedPolicies(sortedPolicies);
  //   } else if (values?.office_id) {
  //     let sortedPolicies = sortPoliciesByOffice(
  //       values?.office_id,
  //       unpaginated_applied_policy
  //     );
  //     setSortedPolicies(sortedPolicies);
  //   } else {
  //     setSortedCustomers([]);
  //   }
  // }, [
  //   unpaginated_applied_policy,
  //   unpaginated_customers,
  //   values?.office_id,
  //   values?.staff_id,
  // ]);

  useEffect(() => {
    if (values?.staff_id) {
      let sortedCustomers = sortCustomersByStaff(
        values?.staff_id,
        unpaginated_customers
      );
      setSortedCustomers(sortedCustomers);
    } else if (values?.office_id) {
      let sortedCustomers = sortCustomersByOffice(
        values?.office_id,
        unpaginated_customers
      );
      setSortedCustomers(sortedCustomers);
    } else {
      setSortedCustomers([]);
    }
  }, [unpaginated_customers, values?.office_id, values?.staff_id]);

  useEffect(() => {
    if (values.claim_category === "other_cover") {
      values.claim_type = '';
    }
  }, [setFieldValue, values, values.claim_category]);


  return (
    <div className='row mb-3'>
      <form className='col-md-10' onSubmit={handleSubmit}>
        <div className='row mt-4'>
          <div className='col-lg-2 col-md-3 text-end sm-text-end'>
            <label htmlFor='account_type' className={`form-label mt-1`}>
              Office
            </label>
          </div>
          <div className='col-sm-6'>
            <Select
              onBlur={() => {
                handleBlur({ target: { name: "office_id" } });
              }}
              name='office_id'
              data={offices?.map((item, i) => ({
                label: item?.office_name,
                value: item?.id,
              }))}
              value={parseInt(values?.office_id)}
              onChange={(selectedOption) => {
                setFieldValue("office_id", selectedOption?.value);
              }}
              ref={officeRef}
            />
          </div>
        </div>
        {page !== "trialBalance" && (
          <div className='row mt-2'>
            <div className='col-lg-2 col-md-3 text-end sm-text-end'>
              <label htmlFor='account_type' className={`form-label mt-1`}>
                Agent
              </label>
            </div>
            <div className='col-sm-6'>
              <Select
                onBlur={() => {
                  handleBlur({ target: { name: "staff_id" } });
                }}
                name='staff_id'
                ref={agentCusRef}
                data={
                  values.office_id === 1 || values.office_id === "1"
                    ? unpaginated_users?.map((item) => ({
                        label: item?.last_name + " " + item?.first_name,
                        value: item?.staff_id,
                      }))
                    : sortedUsers
                }
                value={parseInt(values?.staff_id)}
                onChange={(selectedOption) => {
                  setFieldValue("staff_id", selectedOption?.value);
                  setFieldError("staff_id", "");
                }}
              />
            </div>
          </div>
        )}
        {(page === "policyInfo" ||
          page === "policyExpiry" ||
          page === "claimReport" ||
          page === "customerPayment" ||
          page === "renewedPolicy") && (
          <div className='row mt-2'>
            <div className='col-lg-2 col-md-3 text-end sm-text-end'>
              <label htmlFor='account_type' className={`form-label mt-1`}>
                Policy
              </label>
            </div>
            <div className='col-sm-6'>
              <Select
                onBlur={() => {
                  handleBlur({ target: { name: "policy_id" } });
                }}
                name='policy_id'
                // data={
                //   values.office_id === 1 || values.office_id === "1"
                //     ? unpaginated_applied_policy?.map((item) => ({
                //         label: item?.policyName,
                //         value: item?.policyApplicationNumber,
                //       }))
                //     : sortedPolicies
                // }
                data = {
                  unpaginated_policy?.map((item) => ({
                    label: item?.name,
                    value: item?.id,
                  }))
                }
                value={parseInt(values?.policy_id)}
                onChange={(selectedOption) => {
                  setFieldValue("policy_id", selectedOption?.value);
                }}
                ref={policyRef}
              />
            </div>
          </div>
        )}
        {(page === "individualSavings" ||
          page === "savingsBalance" ||
          page === "savingsInterest" ||
          page === "savingsPerformance" ||
          page === "savingsClaim" ||
          page === "contributionPayment" ||
          page === "savingsInfo" 
         ) && (
          <div className='row mt-2'>
            <div className='col-lg-2 col-md-3 text-end sm-text-end'>
              <label htmlFor='account_type' className={`form-label mt-1`}>
                Savings Policy
              </label>
            </div>
            <div className='col-sm-6'>
              <Select
                onBlur={() => {
                  handleBlur({ target: { name: "savings_policy_id" } });
                }}
                name='savings_policy_id'
                data = {
                  unpaginated_savings_policy?.map((item) => ({
                    label: item?.name,
                    value: item?.id,
                  }))
                }
                value={parseInt(values?.savings_policy_id)}
                onChange={(selectedOption) => {
                  setFieldValue("savings_policy_id", selectedOption?.value);
                }}
                ref={policyRef}
              />
            </div>
          </div>
        )}
        {page === "savingsClaim" && (
          <div className='row mt-2'>
            <div className='col-lg-2 col-md-3 text-end sm-text-end'>
              <label htmlFor='account_type' className={`form-label mt-1`}>
                Claim Category
                {page === "savingsClaim" && (
                  <span className='text-danger'>*</span>
                )}
              </label>
            </div>
            <div className='col-sm-6'>
              <Select
                onBlur={() => {
                  handleBlur({ target: { name: "claim_category" } });
                }}
                name='claim_category'
                data={[{ label: "Other Cover", value: 'other_cover' }, { label: "Savings Claim", value: 'savings_claim' }]}
                value={values?.claim_category}
                onChange={(selectedOption) => {
                  setFieldValue("claim_category", selectedOption?.value);
                }}
                ref={appliedPoliciesRef}
              />
              {errors?.claim_category && (
                <p className='mb-0 text-danger'>{errors?.claim_category + "*"}</p>
              )}
            </div>
          </div>
        )}
        {page === "savingsClaim" && values?.claim_category === "savings_claim" && (
          <div className='row mt-2'>
            <div className='col-lg-2 col-md-3 text-end sm-text-end'>
              <label htmlFor='account_type' className={`form-label mt-1`}>
                Claim Type
              </label>
            </div>
            <div className='col-sm-6'>
              <Select
                onBlur={() => {
                  handleBlur({ target: { name: "claim_type" } });
                }}
                name='claim_type'
                data={claimsType?.map((item, i) => ({
                  label: item?.name,
                  value: item?.id,
                }))}
                value={values?.claim_type}
                onChange={(selectedOption) => {
                  setFieldValue("claim_type", selectedOption?.value);
                }}
                ref={appliedPoliciesRef}
              />
            </div>
          </div>
        )}
        {page === "customerOverview" && (
          <div className='row mt-2'>
            <div className='col-lg-2 col-md-3 text-end sm-text-end'>
              <label htmlFor='account_type' className={`form-label mt-1`}>
                Status
              </label>
            </div>
            <div className='col-sm-6'>
              <Select
                onBlur={() => {
                  handleBlur({ target: { name: "status" } });
                }}
                name='status'
                data={statusData?.map((item, i) => ({
                  label: item?.name,
                  value: item?.id,
                }))}
                value={parseInt(values?.status)}
                onChange={(selectedOption) => {
                  setFieldValue("status", selectedOption?.value);
                }}
                ref={appliedPoliciesRef}
              />
            </div>
          </div>
        )}
        {(page === "policyInfo" || page === "agentReport") && (
          <div className='row mt-2'>
            <div className='col-lg-2 col-md-3 text-end sm-text-end'>
              <label htmlFor='account_type' className={`form-label mt-1`}>
                Policy Status
                {page === "agentReport" && (
                  <span className='text-danger'>*</span>
                )}
              </label>
            </div>
            <div className='col-sm-6'>
              <Select
                onBlur={() => {
                  handleBlur({ target: { name: "policyStatus_id" } });
                }}
                name='policyStatus_id'
                data={policyData?.map((item, i) => ({
                  label: item?.name,
                  value: item?.id,
                }))}
                value={parseInt(values?.policyStatus_id)}
                onChange={(selectedOption) => {
                  setFieldValue("policyStatus_id", selectedOption?.value);
                }}
                ref={policyStatusRef}
              />
              {errors?.policyStatus_id && touched?.policyStatus_id && (
                <p className='mb-0 text-danger'>
                  {errors?.policyStatus_id + "*"}
                </p>
              )}
            </div>
          </div>
        )}
        {(page === "customerPayment" ||
          page === "individualSavings" ||
          page === "claimReport" ||
          page === "savingsClaim" ||
          page === "contributionPayment" ||
          page === "claimReport") && (
          <div className='row mt-2'>
            <div className='col-lg-2 col-md-3 text-end sm-text-end'>
              <label htmlFor='account_type' className={`form-label mt-1`}>
                Customer
              </label>
            </div>
            <div className='col-sm-6'>
              <Select
                onBlur={() => {
                  handleBlur({ target: { name: "customer_id" } });
                }}
                name='customer_id'
                data={
                  values.office_id === 1
                    ? unpaginated_customers?.map((item) => ({
                        label:
                          item?.first_name === null
                            ? item?.business_name
                            : item?.last_name + " " + item?.first_name,
                        value: item?.customer_id,
                      }))
                    : sortedCustomers
                }
                value={parseInt(values?.customer_id)}
                onChange={(selectedOption) => {
                  setFieldValue("customer_id", selectedOption?.value);
                }}
                ref={customerRef}
              />
            </div>
          </div>
        )}
        <div className='row mt-2'>
          <div className='col-lg-2 col-md-3 text-end sm-text-end'>
            <label htmlFor='account_type' className={`form-label mt-1`}>
              Start Date<span className='text-danger'>*</span>
            </label>
          </div>
          <div className='col-sm-6'>
            <input
              type='date'
              id='start_date'
              name='start_date'
              className={`form-control form-control-sm`}
              value={values?.start_date}
              onChange={handleChange}
              onBlur={handleBlur}
            />
            {errors?.start_date && touched?.start_date && (
              <p className='mb-0 text-danger'>{errors?.start_date + "*"}</p>
            )}
          </div>
        </div>
        <div className='row mt-2'>
          <div className='col-lg-2 col-md-3 text-end sm-text-end'>
            <label htmlFor='account_type' className={`form-label mt-1`}>
              End Date<span className='text-danger'>*</span>
            </label>
          </div>
          <div className='col-sm-6'>
            <input
              type='date'
              id='end_date'
              name='end_date'
              className={`form-control form-control-sm`}
              value={values?.end_date}
              onChange={handleChange}
              onBlur={handleBlur}
            />
            {errors?.end_date && touched?.end_date && (
              <p className='mb-0 text-danger'>{errors?.end_date + "*"}</p>
            )}
          </div>
        </div>
        <div className='row mt-2'>
          <div className='col-lg-2 col-md-3'></div>
          <div className='col-sm-6'>
            <div className='d-flex align-items-center gap-2 mt-2'>
              <button type='submit' className='btn btn-sm btn-primary '>
                Generate Report
              </button>
              {filteredItem ? (
                <button
                  type='button'
                  className='btn btn-sm btn-secondary'
                  onClick={clearFilteredItems}
                >
                  Clear Filter
                </button>
              ) : null}
            </div>
          </div>
        </div>
      </form>
      {isLoading && (
        <div
          className='position-absolute top-0 start-0 end-0 bottom d-flex justify-content-center align-items-center transparent-primary z-1000 '
          style={{ height: "100%" }}
        >
          <div className='mx-auto'>
            <BounceLoader
              color='#090b8f'
              loading={true}
              // cssOverride={override}
              size={50}
              aria-label='Loading Spinner'
              data-testid='loader'
              className='ms-3'
            />
            <span className='fw-bolder text-primary-1 ms-2'>
              Generating Report...
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

export default ReportFilter;
